'use client';

import { useUserStore } from '../../auth/UserStoreProvider';
import { useInjectHTML } from '../hooks/useInjectHTML';

type Props = {
  html?: string;
  target: 'head' | 'body';
};

export function InjectHTML({ html, target }: Props) {
  const currentUserDetails = useUserStore().hooks.useCurrentUserDetails();
  useInjectHTML(html, currentUserDetails, target);
  return null;
}
